import { useState } from "react";
import { PricingModelsTab } from "./pricing-models-tab";
import { PricingPlansTab } from "./pricing-plans-tab";

type Tab = "models" | "plans";

export default function AdminPricingPage() {
  const [tab, setTab] = useState<Tab>("models");

  return (
    <div className="mx-auto w-full max-w-[1440px]">
      <h1 className="mb-1 text-2xl font-semibold">Pricing</h1>
      <p className="mb-6 text-sm text-[#526074]">
        Manage model-level credit costs and user-facing plan tiers.
      </p>

      <div className="mb-4 flex gap-2 border-b border-[#DCE3ED]">
        <button
          className={`px-4 py-2 text-sm transition-colors ${
            tab === "models"
              ? "border-b-2 border-black font-medium text-black"
              : "text-[#526074] hover:text-neutral-800"
          }`}
          onClick={() => setTab("models")}
          data-testid="tab-pricing-models"
        >
          Models
        </button>
        <button
          className={`px-4 py-2 text-sm transition-colors ${
            tab === "plans"
              ? "border-b-2 border-black font-medium text-black"
              : "text-[#526074] hover:text-neutral-800"
          }`}
          onClick={() => setTab("plans")}
          data-testid="tab-pricing-plans"
        >
          Plans
        </button>
      </div>

      {tab === "models" && <PricingModelsTab />}
      {tab === "plans" && <PricingPlansTab />}
    </div>
  );
}
